import { render } from "./InputFieldTextArea.vue?vue&type=template&id=473890d3&scoped=true&ts=true"
import script from "./InputFieldTextArea.vue?vue&type=script&lang=ts"
export * from "./InputFieldTextArea.vue?vue&type=script&lang=ts"

import "./InputFieldTextArea.vue?vue&type=style&index=0&id=473890d3&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-473890d3"]])

export default __exports__